import { ChatWidget } from "@/components/chat-widget";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LocaleProvider } from "@/locale-context";
import { ApiRuntimeProvider } from "@/runtime/ApiRuntimeProvider";

export function App() {
  return (
    <LocaleProvider>
      <ApiRuntimeProvider>
        <TooltipProvider>
          <div className="chat-root">
            <ChatWidget />
          </div>
        </TooltipProvider>
      </ApiRuntimeProvider>
    </LocaleProvider>
  );
}
